import { commonTransform } from "../handleTransformation";
import { tags } from "../constants";
import { GET_USER_FILTERS_URL, GET_USERS_URL,GET_MAPPED_RECRUITERS,MAP_RECRUITER, GET_ALL_USERS_URL, GET_USERS_FOR_SPOC_URL, ADD_USER_FROM_ADMIN, UPDATE_USER_FROM_ADMIN } from "services/url.service";

export const userMutations = {
  addRecruiterMapping :  {
    getUrl: ({ userId, companyId } ) => {
        return MAP_RECRUITER({ companyId, userId })
    },
    transformResponse: (res) => commonTransform(res),
    method: "POST",
    invalidatesTags : [tags.USERS]
  },
  deleteRecruiterMapping :  {
    getUrl: ({ userId, companyId } ) => {
        return MAP_RECRUITER({ companyId, userId })
    },
    transformResponse: (res) => commonTransform(res),
    method: "DELETE",
    invalidatesTags : [tags.USERS]
  },
  editRecruiterMapping :  {
    getUrl: ({ userId, companyId } ) => {
        return MAP_RECRUITER({ companyId, userId })
    },
    transformResponse: (res) => commonTransform(res),
    method: "PUT",
    invalidatesTags : [tags.USERS]
  },
  updateUserFromAdmin : {
    getUrl: ({ userId }) => UPDATE_USER_FROM_ADMIN(userId),
    transformResponse: (res) => res,
    method: "PUT",
    invalidatesTags : [tags.USERS]
  },
  addUserFromAdmin : {
    getUrl: () => ADD_USER_FROM_ADMIN,
    transformResponse: (res) => res,
    method: "POST",
    invalidatesTags : [tags.USERS]
  },
};

export const userQueries = {
  getUsers : {
    getUrl: ({ search, offset, limit, sort, filters, companyId } ) => {
        return GET_USERS_URL(companyId, search, offset, limit, filters, sort)
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.USERS],
  },
  getMappedRecruiters : {
    getUrl: ({ search, companyId, supervisorId } ) => {
      return GET_MAPPED_RECRUITERS(companyId, search, supervisorId)
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getAllUsers : {
    getUrl: ({ search, filters, offset } ) =>  GET_ALL_USERS_URL(search, filters, offset),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.USERS],
  },
  getUserFilters : {
    getUrl: (
      { filters , companyId}
    ) => {
        return GET_USER_FILTERS_URL(companyId, JSON.stringify(
          filters
        ))
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getUsersForSpoc : {
    getUrl: () => GET_USERS_FOR_SPOC_URL(),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
};
